import axiosInstance from '../utils/axiosInstance';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const tenantAnalytics = () => {
  return axiosInstance
    .get(API_URL + 'orchestration/tenant_analytics')
    .then((response) => {
      return response.data;
    });
};
const tenantTrendsList = (body) => {
  return axiosInstance
    .post(API_URL + 'orchestration/tenant_analytics_trend',body)
    .then((response) => {
      return response.data;
    });
};

const tenantManagementList = () => {
  return axiosInstance
    .get(API_URL + 'orchestration/tenant_management_list')
    .then((response) => {
      return response.data;
    });
};

const teamManagementList = () => {
  return axiosInstance
    .get(API_URL + 'tenantmaster/getallexecutives')
    .then((response) => {
      return response.data;
    });
};

const  postTenantActivity = (tenant_id,body) => {
  return axiosInstance
  .get(API_URL + `orchestration/tenant_activity/${tenant_id}`, body)
    .then((response) => {
      return response.data;
    });
};

const  createExecutive = (body) => {
  return axiosInstance
  .post(API_URL + `tenantmaster/createexecutive`, body)
    .then((response) => {
      return response.data;
    });
};
const updateExecutive = (userid,body) => {
  return axiosInstance
  .put(API_URL + `tenantmaster/updateexecutive/${userid}`, body)
    .then((response) => {
      return response.data;
    });
};

const deleteExecutive = (user_id) => {
  return axiosInstance
    .delete(API_URL + `tenantmaster/deleteexecutive/${user_id}`)
    .then((response) => {
      return response.data;
    });
};

const createTenant = (body) => {
  return axiosInstance
    .post(API_URL + 'tenantmaster/createtenant', body)
    .then((response) => {
      return response.data;
    });
};

const getAllUserOf_A_Tenant = (tenant_id) => {
  return axiosInstance
    .get(API_URL + `/get/userall/${tenant_id}`)
    .then((response) => {
      return response.data;
    });
};

const createUser = (body) => {
  return axiosInstance
    .post(API_URL + 'tenant/createuser', body)
    .then((response) => {
      return response.data;
    });
};

const deleteUser = ({ tenant_id, user_id }) => {
  return axiosInstance
    .delete(API_URL + `tenant/deleteuser/${tenant_id}/${user_id}`)
    .then((response) => {
      console.log(`deleteExecutive`, response.data);
    });
};

const removeMobile = (tenant_id,user_id,reason,bid,is_ad)  => {
  return axiosInstance
    .post(API_URL + `tenant/removemobile/${tenant_id}/${user_id}`,{'reason':reason,"removed_by":bid,"ba_admin":is_ad})
    .then((response) => {
      return response.data;
    });
};
const deleteTenant = (tenant_id) => {
  return axiosInstance
    .delete(API_URL + `tenantmaster/deletetenant/${tenant_id}`)
    .then((response) => {
      return response.data;
    });
};

const ExecutivePortalService = {
  tenantAnalytics,
  tenantTrendsList,
  tenantManagementList,
  teamManagementList,
  createExecutive,
  updateExecutive,
  deleteExecutive,
  postTenantActivity,
  createTenant,
  getAllUserOf_A_Tenant,
  createUser,
  deleteUser,
  deleteTenant,
  removeMobile
};

export default ExecutivePortalService;